import React from 'react';
import HeadListWrapper from './styled';

const HeadList = () => {

    return (
        <HeadListWrapper>
        <div className='titulo tributos'>
            Tributos
        </div>
        <div className='titulo dataVencimento'>
            Data Vencimento
        </div>
        <div className='titulo cota'>
            Cota
        </div>
        <div className='titulo inscrição'>
            Nº Inscrição
        </div>
        <div className='titulo endereço'>
            Endereço
        </div>
        <div className='titulo valor'>
            Valor
        </div>
        </HeadListWrapper>
    )
}

export default HeadList